export const API_POST_CONVERSIONS_DATA = 'api/cf/post-conversions'
export const API_GET_CONVERSIONS_DATA = 'api/cf/get-conversions'
export const API_GET_GROUPS = 'api/cf/get-groups'
export const API_GET_USER_COMPANY_DATA = 'api/cf/get-user-company-data'
export const API_UPLOAD_CF_CSV_DOCUMENT = 'api/cf/upload-csv-document'

export const getConfig = () => ({
    headers: {
        'Content-Type': 'application/json',
    }
});
export const getFormDataConfig = () => ({
    headers: {
        'Content-Type': 'multipart/form-data'
    }
});
